import { render, staticRenderFns } from "./ComplaintStateIcon.vue?vue&type=template&id=0504d08c&"
import script from "./ComplaintStateIcon.vue?vue&type=script&lang=js&"
export * from "./ComplaintStateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports